import React from "react";
import $ from 'jquery';
import Tools from './utils/Tools';
import Phonecodes from './utils/Phonecodes';
var strings = Tools.getStrings();

export default class WPLogin extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email:"",
            phone:"",
            name:"",
            step:"login",
            recoverPhone:"",
            birthday:"",
            loadFb:false,
            phonecode: "+351",
            companyInfo: {}
        };
    }

    componentDidMount() {
        var _this = this;
        $(document).keypress(function(e) {
            if(e.which === 13) {
                if ($(".login-password").is(":focus")) {
                    _this.login();
                }
            }
        });
    }

    splitAtFirstSpace(str) {
        if (!str) return [];
        var i = str.indexOf(' ');
        if (i > 0) {
            return [str.substring(0, i), str.substring(i + 1)];
        }
        else return [str];
    }

    preRegister() {
        $('.loadingContainerv2').show();
        var name = $('.pre-register-name').val();
        var phone = $('.phone-input').val();
        var email = $('.email').val();

        var validated = true;
        if(name === "") {
            validated = false;
            $('.pre-register-name').addClass('error');
        }else {
            $('.pre-register-name').removeClass('error');
        }
        if(phone.length !== 9) {
            validated = false;
            $('.phone-input').addClass('error');
        }else {
            $('.phone-input').removeClass('error');
        }
        if(email === "") {
            validated = false;
            $('.email').addClass('error');
        }else {
            $('.email').removeClass('error');
        }
        if (!($('input[name="terms"]').is(':checked'))) {
            validated = false;
            $('.terms-txt').addClass('red');
        }else {
            $('.terms-txt').removeClass('red');
        }

        if(validated) {
            window.WebApp.getAccount().preRegister(email, phone, this.state.phonecode, (result) => {
                $('.loadingContainerv2').hide();
                this.setState({
                    email,
                    phone,
                    name,
                    step:"confirmar"
                });
            });
        } else {
            $('.loadingContainerv2').hide();
        }
    }

    preRegisterCompany() {
        $('.loadingContainerv2').show();
        var name = $('.pre-register-name').val();
        var phone = $('.phone-input').val();
        var email = $('.email').val();
        let company = $('.company').val();
        let nif = $('.nif').val();
        let billing_address = $('.billing_address').val();
        let postal_code = $('.postal_code').val();
        let door = $('.door').val();
        let floor = $('.floor').val();
        let city = $('.city').val();
        
        var validated = true;
        if(name === "") {
            validated = false;
            $('.pre-register-name').addClass('error');
        }else {
            $('.pre-register-name').removeClass('error');
        }
        if(phone.length !== 9) {
            validated = false;
            $('.phone-input').addClass('error');
        }else {
            $('.phone-input').removeClass('error');
        }
        if(email === "") {
            validated = false;
            $('.email').addClass('error');
        }else {
            $('.email').removeClass('error');
        }
        if(company === "") {
            validated = false;
            $('.company').addClass('error');
        }else {
            $('.company').removeClass('error');
        }
        if(nif === "") {
            validated = false;
            $('.nif').addClass('error');
        }else {
            $('.nif').removeClass('error');
        }
        if(billing_address === "") {
            validated = false;
            $('.billing_address').addClass('error');
        }else {
            $('.billing_address').removeClass('error');
        }
        if(postal_code === "") {
            validated = false;
            $('.postal_code').addClass('error');
        }else {
            $('.postal_code').removeClass('error');
        }
        if(door === "") {
            validated = false;
            $('.door').addClass('error');
        }else {
            $('.door').removeClass('error');
        }
        if(floor === "") {
            validated = false;
            $('.floor').addClass('error');
        }else {
            $('.floor').removeClass('error');
        }
        if(city === "") {
            validated = false;
            $('.city').addClass('error');
        }else {
            $('.city').removeClass('error');
        }
        if (!($('input[name="terms"]').is(':checked'))) {
            validated = false;
            $('.terms-txt').addClass('red');
        }else {
            $('.terms-txt').removeClass('red');
        }

        if(validated) {
            let companyInfo = {
                name: name,
                email: email,
                phone: phone,
                phonecode: this.state.phonecode,
                company: company,
                nif: nif,
                billing_address: billing_address,
                postal_code: postal_code,
                door: door,
                floor: floor,
                city: city,
                type: $('.company_type').val()
            };
            window.WebApp.getAccount().preRegister(email, phone, this.state.phonecode, (result) => {
                $('.loadingContainerv2').hide();
                this.setState({
                    email,
                    phone,
                    name,
                    companyInfo,
                    step: "confirmar"
                });
            });
        } else {
            $('.loadingContainerv2').hide();
        }
    }

    confirmRegister() {
        $('.loadingContainerv2').show();
        let validated = true;

        let code = $('.code').val();
        let password = $('.password').val();
        let confirmPassword = $('.confirm-password').val();

        if(code.length !== 4) {
            validated = false;
            $('.code').addClass('error');
        }else {
            $('.code').removeClass('error');
        }
        if(password === "" || password !== confirmPassword) {
            validated = false;
            $('.password').addClass('error');
            $('.confirm-password').addClass('error');
        }else {
            $('.password').removeClass('error');
            $('.confirm-password').removeClass('error');
        }

        if(validated) {
            let nameSplit = this.splitAtFirstSpace(this.state.name);
            let name = nameSplit[0];
            let surname = "";
            if(nameSplit.length > 1){
                surname = nameSplit[1];
            }
            let company = false;
            let user = {name:name, surname:surname, phone:this.state.phone, phonecode:this.state.phonecode, email:this.state.email, obs:""};
            if(this.state.companyInfo.name !== undefined) {
                user.companyInfo = this.state.companyInfo;
                company = true;
            }
            window.WebApp.getAccount().register(user, password, code, (result) => {
                let from = localStorage.getItem('from');
                if(company) {
                    if(Tools.getLang() === "pt") {
                        window.location.href="/sucesso-registo";
                    } else {
                        window.location.href="/en/sucesso-registo";
                    }
                } else {
                    if(from === 'checkout') {
                        localStorage.removeItem('from');
                        if(Tools.getLang() === "pt") {
                            window.location.href="/checkout";
                        } else {
                            window.location.href="/en/checkout";
                        }
                    } else {
                        if(Tools.getLang() === "pt") {
                            window.location.href="/areapessoal";
                        } else {
                            window.location.href="/en/areapessoal";
                        }
                    }
                }
            });
        } else {
            $('.loadingContainerv2').hide();
        }
    }

    login() {
        $('.loadingContainerv2').show();
        let validated = true;
        let phone = $('.login-phone').val();
        let password = $('.login-password').val();

        if(phone.length < 9) {
            $('.login-phone').addClass('error');
            validated = false;
        }else {
            $('.login-phone').removeClass('error');
        }
        if(password === "") {
            $('.login-password').addClass('error');
            validated = false;
        }else {
            $('.login-password').removeClass('error');
        }
        if(validated) {
            window.WebApp.getAccount().login(phone, password, (result) => {
                let from = localStorage.getItem('from');
                if(from === 'checkout') {
                    localStorage.removeItem('from');
                    window.location.href="/checkout";
                } else {
                    window.location.href="/areapessoal";
                }
            });
        } else {
            $('.loadingContainerv2').hide();
        }
    }

    recover() {
        this.setState({
            step:"recover"
        });
    }

    recoverAccount() {
        $('.loadingContainerv2').show();
        let validated = true;
        let phone = $('.recover-phone').val();

        if(phone.length !== 9) {
            $('.recover-phone').addClass('error');
            validated = false;
        }else {
            $('.recover-phone').removeClass('error');
        }
        if(validated) {
            window.WebApp.getAccount().recoverAccount(phone, (result) => {
                $('.loadingContainerv2').hide();
                this.setState({
                    recoverPhone:phone,
                    step:"confirmrecover"
                });
            });
        } else {
            $('.loadingContainerv2').hide();
        }
    }

    confirmRecover() {
        $('.loadingContainerv2').show();
        let validated = true;
        let phone = this.state.recoverPhone;
        let code = $('.recover-code').val();
        let password = $('.recover-password').val();
        let confirmPassword = $('.recover-confirm-password').val();

        if(code.length !== 4){
            $('.recover-code').addClass('error');
            validated = false;
        }else {
            $('.recover-code').removeClass('error');
        }
        if(password === "" || password !== confirmPassword) {
            $('.recover-password').addClass('error');
            $('.recover-confirm-password').addClass('error');
            validated = false;
        }else {
            $('.recover-password').removeClass('error');
            $('.recover-confirm-password').removeClass('error');
        }
        if(validated) {
            window.WebApp.getAccount().confirmRecover(phone, password, code, (result) => {
                $('.loadingContainerv2').hide();
                this.setState({
                    step:"login"
                });
            });
        } else {
            $('.loadingContainerv2').hide();
        }
    }

    changeBirthday() {
        let val = $('.birthday').val();
        if(val.length === 2 && this.state.birthday.length < val.length) {
            val = val+"/";
            $('.birthday').val(val);
        }
        if(val.length === 5 && this.state.birthday.length < val.length) {
            val = val+"/";
            $('.birthday').val(val);
        }
        this.setState({
            birthday: val
        });
    }

    render() {
        return (
            <div className="login-page header-padding">
                {this.state.step === "recover" &&
                    <div className="login-column">
                        <h3>{strings.recovertitle}</h3>
                        <p>{strings.insertlogin}</p>
                        <div className="flex between">
                            <select name="phonecode" value={this.state.phonecode} onChange={(e) => this.setState({phonecode: e.target.value})}>
                                {Phonecodes.phonecodes.map((country, index) => {
                                    return (
                                        <option key={index} value={country.dial_code}>{country.code} {country.dial_code}</option>
                                    )
                                })}
                            </select>
                            <input className="custom-input recover-phone flex1" key={9} type="tel" placeholder={strings.phone}/>
                        </div>
                        <div>
                            <button onClick={() => this.recoverAccount()}>
                                {strings.recover}
                            </button>
                            <p className="green pointer" style={{marginBottom:"50px"}}
                                onClick={() => this.setState({step:"login"})}>
                                {strings.haveaccount}
                            </p>
                        </div>
                    </div>
                }
                {this.state.step === "confirmrecover" &&
                    <div className="login-column">
                        <h3>{strings.recovertitle}</h3>
                        <p> {strings.sms}</p>
                        <input className="custom-input recover-code" maxLength="4" key={10} type="tel" placeholder={strings.code}/><br/>
                        <input className="custom-input recover-password" key={11} type="password" placeholder={strings.newpw}/><br/>
                        <input className="custom-input recover-confirm-password" key={12} type="password" placeholder={strings.repeatpw}/><br/>
                        <button style={{margin:"30px auto 20px auto"}}
                            onClick={() => this.confirmRecover()}>
                            {strings.continue}
                        </button>
                    </div>
                }
                {this.state.step === "login" &&
                    <div className="login-column">
                        <h3>{strings.welcome},</h3>
                        <p>{strings.insertlogin}</p>
                        <div className="flex between">
                            <select name="phonecode" value={this.state.phonecode} onChange={(e) => this.setState({phonecode: e.target.value})}>
                                {Phonecodes.phonecodes.map((country, index) => {
                                    return (
                                        <option key={index} value={country.dial_code}>{country.code} {country.dial_code}</option>
                                    )
                                })}
                            </select>
                            <input className="custom-input login-phone flex1" key={1} type="tel" placeholder={strings.phone}/>
                        </div>
                        <input className="custom-input login-password" key={2} type="password" placeholder="Password"/><br/>
                        <p className="green pointer" style={{marginTop:"30px"}}
                            onClick={() => this.setState({step: "recover"})}>
                            {strings.recoverpw}
                        </p>
                        <button onClick={() => this.login()}>
                            {strings.enter}
                        </button>
                        <p className="green" onClick={() => this.setState({step: "registar"})}>
                            {strings.noaccount} <span className="f700 pointer"><u>{strings.registese}</u></span>
                        </p>
                    </div>
                }
                {this.state.step === "registar" &&
                    <div className="login-column">
                        <h3>{strings.createaccount},</h3>
                        <p>{strings.insertlogin}</p>
                        <input className="custom-input pre-register-name" key={3} type="text" placeholder={strings.namesurname}/><br/>
                        <input className="custom-input email" key={5} type="email" placeholder="E-mail"/><br/>
                        <div className="flex between">
                            <select name="phonecode" value={this.state.phonecode} onChange={(e) => this.setState({phonecode: e.target.value})}>
                                {Phonecodes.phonecodes.map((country, index) => {
                                    return (
                                        <option key={index} value={country.dial_code}>{country.code} {country.dial_code}</option>
                                    )
                                })}
                            </select>
                            <input className="custom-input phone-input flex1" key={4} type="tel" placeholder={strings.phone}/>
                        </div>
                        <div style={{marginTop:"10px",paddingLeft:"10px"}}>
                            <input type="checkbox" name="terms" value="terms"/> <span className="terms-txt">{strings.termstxt}<a href="/info/termosecondicoes" target="_blank" className="f700 green">{strings.terms}</a>{strings.termstxt2}<a href="/info/termosecondicoes" target="_blank" className="f700 green">{strings.policy}</a></span><br/>
                        </div>
                        <button onClick={() => this.preRegister()}>
                            {strings.register}
                        </button>
                        <p className="green"
                            onClick={() => this.setState({step:"login"})}>
                            {strings.haveaccount} <span className="f700 pointer" onClick={() => this.setState({step: "login"})}><u>{strings.gologin}</u></span>
                        </p>
                    </div>
                }
                {this.state.step === "confirmar" &&
                    <div className="login-column">
                        <h3>{strings.registration},</h3>
                        <p>{strings.smsconfirm} <span className="f700">{this.state.phonecode} {this.state.phone}</span></p>
                        <input className="custom-input code" maxLength="4" key={6} type="tel" placeholder={strings.code}/><br/>
                        <input className="custom-input password" key={7} type="password" placeholder={strings.choosepw}/><br/>
                        <input className="custom-input confirm-password" key={8} type="password" placeholder={strings.repeatpw}/><br/>
                        <button onClick={() => this.confirmRegister()}>
                            {strings.confirm}
                        </button>
                        <p className="center-text" style={{marginTop:"20px"}}>{strings.wrongnum}</p>
                        <p className="center-text f700 green" onClick={() => this.setState({step: "registar"})}><u>{strings.goback}</u></p>
                    </div>
                }
            </div>
        );
    }
}
